module.exports = __webpack_public_path__ + "static/img/ministry-of-justice-foreigners.e78461c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ministry-of-justice-foreigners.jpg
// module id = deCs
// module chunks = 0